import { CheckIcon } from "../../components/icons/CheckIcon";

const CircleCheckBox = ({ input, label, className = '' }) => {
  const isChecked = input.value === true || input.value === 'true';
  
  const handleClick = () => {
    input.onChange(!isChecked);
  };
  
  return (
    <div className={`d-flex align-items-center cursor-pointer select-none ${className}`} onClick={handleClick}>
      <div className="relative">
        <div 
          className={`
            d-flex align-items-center justify-content-center
            rounded-checkbox
            rounded-checkbox--${isChecked ? 'checked' : 'unchecked'}
          `}
        >
          {isChecked && (
            <CheckIcon color="white" height={10} width={12} />
          )}
        </div>
      </div>
      {label && (
        <span className="ml-3 text-gray-700 font-medium">{label}</span>
      )}
    </div>
  );
};

export { CircleCheckBox };